// gordon-0916-collection-selected-indicator-more-margin (Gordon 2026-09-16:
// "The Selected indicator box around the collection is too snug - add more
// margin"). MEASURED on web-dev main.8a0b105d.js: the purple ring WAS the
// tile's own 1px border with padding 0 -> 1px between ring and cover. The ring
// now sits OUTSIDE the tile, offset by this ONE shared token, so the tile's
// geometry (and every sibling/label measurement pinned against it) is
// unchanged. Matching-corner-rounding law: the ring's radius is the tile
// radius + the offset, so the two curves stay concentric.
//
// Plain numbers only (no theme/colour imports) so any container that clips a
// tile can reserve room for the ring without pulling in FoldersV2/styles.js.
export const COLLECTION_TILE_RADIUS = 12;
export const COLLECTION_SELECTED_RING_OFFSET = 6;
export const COLLECTION_SELECTED_RING_WIDTH = 1;
export const COLLECTION_SELECTED_RING_RADIUS =
  COLLECTION_TILE_RADIUS + COLLECTION_SELECTED_RING_OFFSET;
// Room a clipping container (the overflow carousel row, the picker's scroll
// list) must leave around a tile so the outset ring is never cut off.
export const COLLECTION_SELECTED_RING_OUTSET =
  COLLECTION_SELECTED_RING_OFFSET + COLLECTION_SELECTED_RING_WIDTH;
